// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yYIk","type":"styles_type__7an6V","choices":"styles_choices__1ZM3K"};